import {NewCaseNotification} from "@prosay/common"
import {getLogger} from "@prosay/logging"
import {NotifcationHandler} from "../types"

const logger = getLogger(__filename)

export const newCase: NotifcationHandler<NewCaseNotification> = logger.debug(
    ({data: {}, origin}) => {
        origin
        // TODO: Add a proper handler for the newCase notification
    },
    "NotificationHandler::newCase",
)
